import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  console.log(theme);
  return {
    footerContainer: {
      padding: '18px 50px',
      display: 'flex',
      alignItems: 'center',
      background: theme.palette.background.paper,
    },
    footerLinks: {
      margin: '0 8px'
    },
    poweredByContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& svg': {
        fill:
          theme.palette.type === 'light'
            ? theme.palette.common.black
            : theme.palette.common.white
      }
    }
  };
});

export default useStyles;
